import {
  FETCH_SUMMARY,
  FETCH_SUMMARY_ERROR,
  FETCH_SUMMARY_SUCCESS,
  CREATE_SUMMARY,
  CREATE_SUMMARY_ERROR,
  CREATE_SUMMARY_SUCCESS,
  UPDATE_SUMMARY,
  UPDATE_SUMMARY_ERROR,
  UPDATE_SUMMARY_SUCCESS,
} from '../actions/summary';

export default function (state = [], action) {
  switch (action.type) {
  case FETCH_SUMMARY:
    return { ...state, isFetching: true };
  case FETCH_SUMMARY_SUCCESS:
    return {
      ...state,
      summaries: action.payload.data,
      isFetching: false,
    };
  case FETCH_SUMMARY_ERROR:
    return { ...state, error: action.error, isFetching: false };
  case UPDATE_SUMMARY:
  case CREATE_SUMMARY:
    return { ...state, isFetching: true };
  case UPDATE_SUMMARY_SUCCESS:
  case CREATE_SUMMARY_SUCCESS:
    return Object.assign({}, ...state, {
      summaries: [Object.assign({}, state.summaries[0], {
        ...action.payload.data,
      })],
      isFetching: false,
    });
  case UPDATE_SUMMARY_ERROR:
  case CREATE_SUMMARY_ERROR:
    return { ...state, error: action.error, isFetching: false };

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_summary.js